// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
	}
};

(function() {
	BoostPFS.inject(this);

	var gmcProductHeroCache = {};

	function gmcForceHeroImageInInstantSearch(scope) {
		var $scope = scope ? jQ(scope) : jQ(document);
		$scope.find('a[href*="/products/"]').each(function() {
			var $link = jQ(this);
			var href = String($link.attr('href') || '');
			var productHandle = extractProductHandle(href);

			if (!productHandle) {
				return;
			}

			var $image = $link.find('img').first();
			if (!$image.length) {
				$image = $link.closest('li').find('img').first();
			}

			if (!$image.length) {
				return;
			}

			applyHeroImageForHandle(productHandle, $image);
		});
	}

	function extractProductHandle(href) {
		var match = href.match(/\/products\/([^?#/]+)/);
		return match ? match[1] : '';
	}

	function applyHeroImageForHandle(productHandle, $image) {
		if (gmcProductHeroCache.hasOwnProperty(productHandle)) {
			setInstantSearchImage($image, gmcProductHeroCache[productHandle]);
			return;
		}

		jQ.getJSON('/products/' + productHandle + '.js')
			.done(function(product) {
				var heroImageUrl = '';
				if (product && Array.isArray(product.images) && product.images.length > 1) {
					heroImageUrl = product.images[1];
				}

				gmcProductHeroCache[productHandle] = heroImageUrl;
				setInstantSearchImage($image, heroImageUrl);
			})
			.fail(function() {
				gmcProductHeroCache[productHandle] = '';
			});
	}

	function setInstantSearchImage($image, heroImageUrl) {
		if (!heroImageUrl) {
			return;
		}

		$image.attr('src', heroImageUrl);
		$image.attr('data-src', heroImageUrl);
		$image.removeAttr('srcset');
		$image.removeAttr('data-srcset');
	}

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
	};

	var gmcOriginalRenderMenu = SearchInput.prototype._bindAutoCompleteRenderMenu;
	SearchInput.prototype._bindAutoCompleteRenderMenu = function(element, items) {
		gmcOriginalRenderMenu.call(this, element, items);
		gmcForceHeroImageInInstantSearch(element);
	};

	var gmcOriginalOnOpenAutocomplete = SearchInput.prototype.onOpenAutocomplete;
	SearchInput.prototype.onOpenAutocomplete = function(event, ui) {
		gmcOriginalOnOpenAutocomplete.call(this, event, ui);
		if (this.instantSearchResult && this.instantSearchResult.$wrapper) {
			gmcForceHeroImageInInstantSearch(this.instantSearchResult.$wrapper);
		}
	};

	/* Boost #93442*/
    InstantSearchApi.beforeCall = function(eventType, eventInfo) {
      if (boostPFSConfig.shop.tags && boostPFSConfig.shop.tags.length > 0) {
        if (boostPFSConfig.shop.tags.includes('REFERIDO')) {
          Globals.instantSearchQueryParams = {tag: 'pfs:on-referido'};
		}
        if (boostPFSConfig.shop.tags.includes('EMPLEADO')) {
          Globals.instantSearchQueryParams = {tag: 'pfs:on-empleado'};
		}
	  }
    }
	/* Boost #93442*/
})();
